import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import Dialog from '@material-ui/core/Dialog';

@inject('userStore')
@observer
class DialogWrapper extends Component {
    render() {
        const {userStore, ...rest} = this.props;
        return (
            <Dialog dir={userStore.localeDirection} {...rest}/>
        );
    }
}

export default DialogWrapper;
